import { __, data, isstring, isuuid, matches } from "@deckchair-technicians/vice";

@data
export class PatientSyncR4Message {
  type: 'patient-sync' = 'patient-sync';
  r4PatientId: string = __(matches(/[0-9]*/));
  patientPatchId: string = __(isuuid());
}

@data
export class TestR4Message {
  type: 'test' = 'test';
}

@data
export class QuestionnaireQuestionsUploadR4Message {
  type: 'questionnaire-questions-upload' = 'questionnaire-questions-upload';
}

@data
export class QuestionnaireAnswersUploadR4Message {
  type: 'questionnaire-answers-upload' = 'questionnaire-answers-upload';
}

@data
export class BulkUploadPatientR4Message {
  type: 'bulk-upload-patients' = 'bulk-upload-patients';
}

@data
export class RestartR4Message {
  type: 'restart' = 'restart';
}

@data
export class BulkUploadAppointmentsR4Message {
  type: 'bulk-upload-appointments' = 'bulk-upload-appointments';
}

@data
export class BulkUploadAppointmentStatusR4Message {
  type: 'bulk-upload-appointment-status' = 'bulk-upload-appointment-status';
}

export type R4Message = PatientSyncR4Message |
  TestR4Message |
  QuestionnaireQuestionsUploadR4Message |
  QuestionnaireAnswersUploadR4Message |
  BulkUploadPatientR4Message |
  RestartR4Message |
  BulkUploadAppointmentsR4Message |
  BulkUploadAppointmentStatusR4Message;
